
/*
  Created 
    by: Upendram Reddy Tanuja
    on: 21-Aug-2019 07:30 PM
    purpose: Active Page component
    comments: Active Page  details
*/

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-active-page',
  templateUrl: './active-page.component.html',
  styleUrls: ['./active-page.component.scss']
})
export class ActivePageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
